import React from "react"
import * as styles from "./switcherTextBlock.module.scss"

export const RequirementsSticker = () => (
  <div className={styles.htmlBlock}>
    <h4>Требования к взрослому клиенту (родителю)</h4>
    <ul>
      <li>Гражданство РФ;</li>
      <li>Паспорт РФ*;</li>
      <li>Возраст от 18 до 75 лет;</li>
      <li>
        Официальное трудоустройство (стаж на&nbsp;последнем месте работы не&nbsp;менее
        4&nbsp;месяцев);
      </li>
      <li>
        Наличие постоянной регистрации не&nbsp;менее 4&nbsp;последних месяцев на&nbsp;территории
        одного населенного пункта РФ, проживание в&nbsp;городе присутствия подразделения Банка
        или&nbsp;в&nbsp;одном из&nbsp;прилегающих населенных пунктов (но&nbsp;не&nbsp;более
        70&nbsp;километров от&nbsp;любого внутреннего структурного подразделения Банка).
      </li>
      <li>Наличие личного мобильного телефона.</li>
    </ul>
    <p>
      * При необходимости или недостаточности сведений Банк имеет право запросить дополнительную
      информацию о&nbsp;клиенте (документы, подтверждающие владение имуществом: квартирой,
      транспортным средством и&nbsp;т. д.), в&nbsp;том числе и дополнительные документы (второй
      документ, удостоверяющий личность; документы, подтверждающие доход клиента).
    </p>
  </div>
)
